import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";

export interface JobType {
    id: string;
    title: string;
    created_at: string;
    status: string;
    likes_count: number;
}

export const QUERY_KEY_FOR_JOBS = "recruiter-jobs";

const getJobsData = async (token: string): Promise<JobType[]> => {
    const url = `${END_POINT.BASE_URL}/v1/dashboardjobs`;
    const config = {
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        },
    };

    const res = await axios.get(url, config);
    return res.data;
};

export const useGetDashboardJobs = (token: string) => {
    return useQuery(
        [QUERY_KEY_FOR_JOBS],
        () => getJobsData(token),
        {
            enabled: !!token,
            staleTime: 5 * 60 * 1000,
        }
    );
};